import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

//Circular progress with label and percentage
const CircularProgressWithLabel = (props) => {
  const { label, ...otherProps } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} {...otherProps}>
      {label ? (
        <Typography variant="caption" component="div" color="text.secondary">
          {label}
        </Typography>
      ) : (
        ""
      )}
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress />
      </Box>
    </div>
  );
};

export default CircularProgressWithLabel;
